import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { Doughnut } from "react-chartjs-2";
import CommonFooter from "../../core/common/footer/commonFooter";
import Table from "../../core/pagination/datatable";
import { Spin, notification, Modal, Input, Button, Form } from "antd";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import {
  getApiBaseUrl,
  GET_ADMIN_DASHBOARD_COUNT,
  GET_BAR_GRAPH,
  GET_STAGE_COUNT,
  // GET_USER_DASHBOARD_COUNT,
  GET_SCHEDULE,
  ADD_ACTIVITY,
} from "./Config/Config";
import NewUserRequests from "./NewUserRequests";

const AssetManagement = () => {
  const [currentStateData, setCurrentStateData] = useState(null);
  const [barGraphData, setBarGraphData] = useState(null);
  const [roleCounts, setRoleCounts] = useState([]);

  // === COMMENTED OUT: This was used before, but now we use dashboardBreakdown for cards ===
  // === Keeping it commented so nothing is removed, but no longer used in cards ===
  // const [UserDashboardCount, setUserDashboardCount] = useState({});
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [tableloading, setTableLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [requestsLoading, setRequestsLoading] = useState(false);
  const [loadingReset, setLoadingReset] = useState(false);
  const [latestSchedules, setLatestSchedules] = useState([]);
  const [isReauthModalVisible, setIsReauthModalVisible] = useState(false);
  const [reauthAction, setReauthAction] = useState(null);
  const [reauthForm] = Form.useForm();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const currentUsername = user?.UserName || "";

  // === ACTIVE: This is the correct source for dashboard cards (has Process/Non-Process breakdown) ===
  const [dashboardBreakdown, setDashboardBreakdown] = useState({
    Printers: 0,
    Filters: 0,
    Retired: 0,
    RetiredProcessed: 0,
    RetiredNonProcessed: 0,
    ReplacementTotal: 0,
    ReplacementProcessed: 0,
    ReplacementNonProcessed: 0,
    Blocks: 0,
    FilterProcessed: 0,
    FilterNonProcessed: 0,
  });

  // Fetch the correct API with full breakdown
  const fetchDashboardBreakdown = async () => {
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/Dashboard/getDashboardCount`,
      );
      const result = await response.json();

      if (result.Status && result.ResultData && result.ResultData.length > 0) {
        setDashboardBreakdown(result.ResultData[0]);
      }
    } catch (error) {
      console.error("Error fetching dashboard breakdown:", error);
    }
  };

  useEffect(() => {
    fetchDashboardBreakdown();
  }, []);

  // Re-fetch when UserType changes (All/Process/Non-Process)
  useEffect(() => {
    const handleFilterChange = () => {
      console.log("pppppppppppppppppppppppppppppppppppp");

      fetchDashboardBreakdown();
    };

    window.addEventListener("filtertypechange", handleFilterChange);

    return () => {
      window.removeEventListener("filtertypechange", handleFilterChange);
    };
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);

      const endpoints = [
        {
          key: "currentStateData",
          url: `${getApiBaseUrl()}${GET_STAGE_COUNT}`,
        },
        {
          key: "barGraphData",
          url: `${getApiBaseUrl()}${GET_BAR_GRAPH}`,
        },
        {
          key: "roleCounts",
          url: `${getApiBaseUrl()}${GET_ADMIN_DASHBOARD_COUNT}`,
        },
        // === COMMENTED: We no longer need this for cards, but keeping for potential future use ===
        // {
        //   key: "UserDashboardCount",
        //   url: `${getApiBaseUrl()}${GET_USER_DASHBOARD_COUNT}`,
        // },
      ];

      const responses = await Promise.allSettled(
        endpoints.map((ep) =>
          fetch(ep.url).then((res) => {
            if (!res.ok)
              throw new Error(`${ep.key} failed with status ${res.status}`);
            return res.json();
          }),
        ),
      );

      responses.forEach((result, index) => {
        const key = endpoints[index].key;

        if (result.status === "fulfilled") {
          const data = result.value?.ResultData;

          switch (key) {
            case "currentStateData": {
              const stageMap = {
                "Storage-in": "inStorage",
                "Storage-out": "inUse",
                "Dry-in": "inDryer",
                New: "awaitingWash",
                Retired: "retired",
              };

              const transformedData = {};

              if (Array.isArray(data)) {
                data?.forEach((item) => {
                  const key = stageMap[item?.StageName];
                  if (key) {
                    transformedData[key] = item?.RecordCount;
                  }
                });
              }

              setCurrentStateData(transformedData);
              break;
            }
            case "barGraphData": {
              const allStages = [
                "New",
                "Washin",
                "Washout",
                "Dryin",
                "Dryout",
                "Storagein",
                "Storageout",
                "Installation",
                "IssueSpare",
                "InstallationComplete",
                "Retired",
              ];

              const formattedData = {};
              allStages.forEach((stage) => {
                formattedData[stage] = [];
              });

              if (Array.isArray(data)) {
                data.forEach((monthData) => {
                  allStages.forEach((stage) => {
                    formattedData[stage].push(monthData[stage] ?? 0);
                  });
                });
              }

              setBarGraphData(formattedData);
              break;
            }
            case "roleCounts": {
              const roleMap = {
                2: "admin",
                4: "supervisor",
                5: "operator",
                3: "reviewer",
              };

              const mappedRoles = {};
              if (Array.isArray(data)) {
                data.forEach((item) => {
                  const roleName = roleMap[item.role];
                  if (roleName) {
                    mappedRoles[roleName] = item.rolecount;
                  }
                });
              }
              setRoleCounts(mappedRoles);
              break;
            }
            // === COMMENTED: No longer setting UserDashboardCount ===
            // case "UserDashboardCount":
            //   setUserDashboardCount(data?.[0] || {});
            //   break;
            default:
              break;
          }
        } else {
          console.error(`Failed to fetch ${key}:`, result.reason);
        }
      });

      setLoading(false);
    };

    fetchAllData();
  }, []);

  const userTypeStr = sessionStorage.getItem("UserType");
  const userType = userTypeStr ? parseInt(userTypeStr) : 0;
  console.log(userType, "userType");

  useEffect(() => {
    const handleFilterChange = () => {
      console.log("zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz");

      setDashboardBreakdown((prev) => ({ ...prev }));
    };

    window.addEventListener("filtertypechange", handleFilterChange);

    return () => {
      window.removeEventListener("filtertypechange", handleFilterChange);
    };
  }, []);

  const fetchSchedules = async () => {
    setTableLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_SCHEDULE}`);
      const result = await response.json();

      if (result?.Status && Array.isArray(result?.ResultData)) {
        setSchedules(result.ResultData);
      } else {
        console.error("Unexpected API format:", result);
        setSchedules([]);
      }
    } catch (error) {
      console.error("Failed to fetch schedules:", error);
      setSchedules([]);
    } finally {
      setTableLoading(false);
    }
  };

  // === COMMENTED OUT: duplicate useEffect (handled above) ===
  // useEffect(() => {
  //   const handleFilterChange = () => {
  //     fetchDashboardCounts(); // Re-fetch to ensure latest data, then UI will recompute
  //   };

  //   window.addEventListener("filtertypechange", handleFilterChange);

  //   return () => {
  //     window.removeEventListener("filtertypechange", handleFilterChange);
  //   };
  // }, []);
  // === END COMMENTED OUT ===

  const handleReauthentication = async (values) => {
    try {
      const response = await fetch(`${getApiBaseUrl()}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: currentUsername,
          password: values.password,
        }),
      });

      const loginData = await response.json();

      if (loginData.status && loginData.Message === "Login successful") {
        setIsReauthModalVisible(false);
        reauthForm.resetFields();
        await performResetPassword(reauthAction.record);
      } else {
        Swal.fire("Error", loginData?.Message, "error");
      }
    } catch (error) {
      console.error("Reauthentication error:", error);
      Swal.fire(
        "Error",
        "Reauthentication failed due to a network error.",
        "error",
      );
    }
  };

  const performResetPassword = async (record) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user?.UserID || 0;
    setLoadingReset(true);
    try {
      const changePasswordResponse = await fetch(
        `${getApiBaseUrl()}/adminChangePassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: record?.Email,
            PerformedBy: String(userId),
          }),
        },
      );

      const changePasswordData = await changePasswordResponse.json();

      if (!changePasswordData.status) {
        throw new Error(
          changePasswordData.message || "Password change failed.",
        );
      }

      const tempPassword = changePasswordData?.ResultData?.TemporaryPassword;

      const activityPayload = {
        ActivityType: 9,
        PerformedBy: userId,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Initiated password reset for ${record?.Email}`,
        Location: "resetpassword",
        IsSucces: 1,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });

      Swal.fire({
        title: "Temporary Password Generated",
        html: `
          <p>User <b>${record?.Name}</b> password has been reset.</p>
          <p><b>Temporary Password:</b> <code id="tempPass">${tempPassword}</code></p>
          <button id="copyBtn" class="swal2-confirm swal2-styled">Copy </button>
        `,
        showConfirmButton: false,
        didOpen: () => {
          const copyBtn = Swal.getPopup().querySelector("#copyBtn");
          copyBtn.addEventListener("click", () => {
            navigator.clipboard
              .writeText(tempPassword)
              .then(() => {
                Swal.fire(
                  "Copied!",
                  "Temporary password copied to clipboard.",
                  "success",
                );
              })
              .catch(() => {
                Swal.fire("Error", "Failed to copy to clipboard.", "error");
              });
          });
        },
      });
      fetchForgotPasswordRequests();
    } catch (error) {
      console.error("Error in resetting password:", error);
      const activityPayload = {
        ActivityType: 9,
        PerformedBy: userId,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Initiated password reset for ${record?.Email}`,
        Location: "resetpassword",
        IsSucces: 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setLoadingReset(false);
    }
  };

  const handleResetPassword = async (record) => {
    setReauthAction({ type: "resetPassword", record });
    setIsReauthModalVisible(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
    },
    {
      title: "Username",
      dataIndex: "Email",
      key: "email",
    },
    {
      title: "Requested On",
      dataIndex: "RequestedOn",
      key: "requestedOn",
      render: (text) => dayjs(text).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="confirm-text me-2 p-2"
              title="reset password"
              to="#"
              onClick={() => handleResetPassword(record)}
            >
              <i className="fa-solid fa-key"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const fetchForgotPasswordRequests = async () => {
    setRequestsLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/getForgotPasswordRequests`,
      );
      const result = await response.json();
      if (result?.status) {
        setRequests(result.ResultData || []);
      } else {
        setRequests([]);
      }
    } catch (error) {
      console.error("Failed to fetch forgot password requests:", error);
      setRequests([]);
    } finally {
      setRequestsLoading(false);
    }
  };

  useEffect(() => {
    fetchForgotPasswordRequests();
  }, []);

  useEffect(() => {
    fetchSchedules();
  }, []);

  useEffect(() => {
    if (schedules && Array.isArray(schedules)) {
      const last15 = schedules.slice(-15);
      setLatestSchedules(last15);
    }
    setTableLoading(false);
  }, [schedules]);

  const roleId = parseInt(sessionStorage.getItem("selectedRole"));

  const stateColors = {
    "In Use": "#1e88e5",
    "In Storage": "#90caf9",
    "In Dryer": "#fbc531",
    Replaced: "#e17055",
    "Awaiting Wash": "#e17055",
    Retired: "#455a64",
  };

  const salesDayChart = {
    chart: {
      height: 245,
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },

    theme: {
      mode: "default",
      palette: "none", // Disables auto blue theme
    },
    colors: [
      stateColors["In Use"],
      stateColors["In Storage"],
      stateColors["In Dryer"],
      stateColors["Replaced"],
    ],

    plotOptions: {
      bar: {
        columnWidth: "70%",
        borderRadius: 8,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",

        distributed: false,
      },
    },

    series: [
      {
        name: "In Use",
        data: barGraphData?.New || [],
      },
      {
        name: "Washed",
        data: barGraphData?.Storagein || [],
      },
      {
        name: "Dryed",
        data: barGraphData?.Dryout || [],
      },
      {
        name: "Retired",
        data: barGraphData?.Retired || [],
      },
    ],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
    },
  };

  const pieData = {
    labels: ["In Use", "In Storage", "In Dryer", "Awaiting Wash", "Retired"],
    datasets: [
      {
        label: "Asset States",
        data: [
          currentStateData?.inUse,
          currentStateData?.inStorage,
          currentStateData?.inDryer,
          currentStateData?.awaitingWash,
          currentStateData?.retired,
        ],
        backgroundColor: [
          stateColors["In Use"],
          stateColors["In Storage"],
          stateColors["In Dryer"],
          stateColors["Awaiting Wash"],
          stateColors["Retired"],
        ],
        borderWidth: 1,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
  };

  useEffect(() => {
    notification.success({
      message: "Login Successful",
      description: "Welcome back to the dashboard!",
      placement: "topRight",
      duration: 3,
    });
  }, []);

  const assetCards = [
    {
      label: "Filters",
      value:
        userType === 0
          ? dashboardBreakdown.Filters
          : userType === 1
            ? dashboardBreakdown.FilterProcessed
            : dashboardBreakdown.FilterNonProcessed,
      bgClass: "bg-secondary",
      textClass: "text-secondary",
      iconClass: "bi bi-funnel",
    },
    {
      label: "Retired",
      value:
        userType === 0
          ? dashboardBreakdown.Retired
          : userType === 1
            ? dashboardBreakdown.RetiredProcessed
            : dashboardBreakdown.RetiredNonProcessed,
      bgClass: "bg-warning",
      textClass: "text-warning",
      iconClass: "bi bi-wrench",
    },
    {
      label: "Replaced",
      value:
        userType === 0
          ? dashboardBreakdown.ReplacementTotal
          : userType === 1
            ? dashboardBreakdown.ReplacementProcessed
            : dashboardBreakdown.ReplacementNonProcessed,
      bgClass: "bg-primary",
      textClass: "text-primary",
      iconClass: "bi bi-arrow-repeat",
    },
    {
      label: "Blocks",
      value: dashboardBreakdown.Blocks,
      bgClass: "bg-teal",
      textClass: "text-teal",
      iconClass: "bi bi-boxes",
    },
  ];

  console.log(dashboardBreakdown, "  dashboardBreakdown");

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      {loadingReset && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        {(roleId === 5 || roleId === 3 || roleId === 4) && (
          <div className="content">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
              <div className="mb-3">
                <h1 className="mb-1">Filter Tracking</h1>
                {/* <p className="fw-medium">
                  You have <span className="text-primary fw-bold">20+</span>
                  New Filters, Today
                </p> */}
              </div>
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-sm btn-success me-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasAddUserRewquest"
                >
                  <i className="ti ti-user-plus fs-4"></i>
                </Link>
              </div>
            </div>

            <div className="row">
              {assetCards.map((card, index) => (
                <div key={index} className="col-xl-3 col-sm-6 col-12 d-flex">
                  <Link
                    className={`card ${card.bgClass} sale-widget flex-fill`}
                  >
                    <div className="card-body d-flex align-items-center">
                      <span className={`sale-icon bg-white ${card.textClass}`}>
                        <i className={`${card.iconClass} fs-2`} />
                      </span>
                      <div className="ms-2">
                        <p className="text-white fw-bold mb-1">{card.label}</p>
                        <div className="d-inline-flex align-items-center flex-wrap gap-2">
                          <h4 className="text-white">{card.value}</h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-xxl-8 col-xl-8 col-md-12 col-lg-8 col-sm-12 col-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="d-inline-flex align-items-center">
                      <span className="title-icon bg-soft-primary fs-16 me-2">
                        <i className="ti ti-packages" />
                      </span>
                      <h5 className="card-title mb-0">Monthly Filter State </h5>
                    </div>
                  </div>
                  <div className="card-body pb-0">
                    <div>
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        {/* In Use */}
                        <div
                          className="border p-2 br-8"
                          style={{ backgroundColor: "#1e88e5" }}
                        >
                          <p className="d-inline-flex align-items-center text-white mb-1">
                            <i
                              className="ti ti-circle-filled fs-8 me-1"
                              style={{ color: "#e3f2fd" }}
                            />
                            In Use
                          </p>
                        </div>

                        {/* Storage */}
                        <div
                          className="border p-2 br-8"
                          style={{ backgroundColor: "#90caf9" }}
                        >
                          <p className="d-inline-flex align-items-center text-white mb-1">
                            <i
                              className="ti ti-circle-filled fs-8 me-1"
                              style={{ color: "#e8f0fe" }}
                            />
                            Storage
                          </p>
                        </div>

                        {/* Dryer */}
                        <div
                          className="border p-2 br-8"
                          style={{ backgroundColor: "#fbc531" }}
                        >
                          <p className="d-inline-flex align-items-center text-white mb-1">
                            <i
                              className="ti ti-circle-filled fs-8 me-1"
                              style={{ color: "#fff8e1" }}
                            />
                            Dryer
                          </p>
                        </div>

                        {/* Replaced */}
                        <div
                          className="border p-2 br-8"
                          style={{ backgroundColor: "#e17055" }}
                        >
                          <p className="d-inline-flex align-items-center text-white mb-1">
                            <i
                              className="ti ti-circle-filled fs-8 me-1"
                              style={{ color: "#ffe5d0" }}
                            />
                            Replaced
                          </p>
                        </div>
                      </div>

                      <div id="sales-daychart">
                        <Chart
                          options={salesDayChart}
                          series={salesDayChart.series}
                          type="bar"
                          height={245}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl-4 col-md-12 col-lg-4 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-inline-flex align-items-center">
                      <span className="title-icon bg-soft-success fs-16 me-2">
                        <i className="ti ti-chart-pie" />
                      </span>
                      <h5 className="card-title mb-0">Todays state</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-center">
                      <div style={{ height: "250px", width: "250px" }}>
                        <Doughnut data={pieData} options={pieOptions} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card d-none">
              <div className="card-header">
                <h4 className="card-title">
                  {" "}
                  <i className="fas fa-wind me-2"></i>Due for Cleaning
                </h4>
              </div>
              <div className="card-body">
                <Spin spinning={tableloading}>
                  <div className="table-responsive dataview">
                    <table className="table dashboard-expired-products">
                      <thead className="thead-light">
                        <tr>
                          {/* <th className="no-sort">
                            <label className="checkboxs">
                              <input id="select-all" type="checkbox" />
                              <span className="checkmarks"></span>
                            </label>
                          </th> */}
                          <th>Filter ID</th>
                          <th>Scheduled Date</th>
                          <th>Location</th>
                          <th>Expired Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {latestSchedules.map((item) => (
                          <tr key={item.id}>
                            {/* <td>
                              <label className="checkboxs">
                                <input type="checkbox" />
                                <span className="checkmarks"></span>
                              </label>
                            </td> */}
                            <td>
                              <div className="d-flex align-items-center">
                                <a>{item.Lable}</a>
                              </div>
                            </td>
                            <td>
                              {dayjs(item.ScheduledDate).format("DD/MM/YYYY")}
                            </td>
                            <td>{item.locatinname}</td>
                            <td>
                              {dayjs(item.InstalledOn).format("DD/MM/YYYY")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Spin>
              </div>
            </div>
            {/* <div className="card">
              <div className="card-header">
                <div className="search-set no-search"></div>
                <h4 className="card-title "> Due for Cleaning</h4>
              </div>
              <div className="card-body">{ tableloading?
                <Table columns={columns} dataSource={dataSource} pagination={false}/>
             :"No data"} </div>
            </div> */}
          </div>
        )}

        {roleId === 2 && (
          <div className="content">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
              <div className="mb-3">
                <h1 className="mb-1">Admin Dashboard</h1>
                <p className="fw-medium">
                  Oversee{" "}
                  <span className="text-primary fw-bold">User Access</span> and{" "}
                  <span className="text-success fw-bold">Filter Logs</span>
                </p>
              </div>
            </div>

            {/* Admin Function Cards */}
            <div className="row">
              {/* Admin */}
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-primary text-white flex-fill">
                  <div className="card-body d-flex align-items-center">
                    <span className="sale-icon bg-white text-primary rounded">
                      <i className="ti ti-user-shield fs-2" />
                    </span>
                    <div className="ms-2">
                      <p className="fw-bold mb-1">Admin</p>
                      <h4 className="text-white">{roleCounts?.admin ?? 0} </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reviewer */}
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-success text-white flex-fill">
                  <div className="card-body d-flex align-items-center">
                    <span className="sale-icon bg-white text-success rounded">
                      <i className="ti ti-user-check fs-2" />
                    </span>
                    <div className="ms-2">
                      <p className="fw-bold mb-1">Reviewer</p>
                      <h4 className="text-white">
                        {roleCounts?.reviewer ?? 0}{" "}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Supervisor */}
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-warning text-white flex-fill">
                  <div className="card-body d-flex align-items-center">
                    <span className="sale-icon bg-white text-warning rounded">
                      <i className="ti ti-user-star fs-2" />
                    </span>
                    <div className="ms-2">
                      <p className="fw-bold mb-1">Supervisor</p>
                      <h4 className="text-white">
                        {roleCounts?.supervisor ?? 0}{" "}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Operator */}
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-secondary text-white flex-fill">
                  <div className="card-body d-flex align-items-center">
                    <span className="sale-icon bg-white text-secondary rounded">
                      <i className="ti ti-users fs-2" />
                    </span>
                    <div className="ms-2">
                      <p className="fw-bold mb-1">Operator</p>
                      <h4 className="text-white">
                        {roleCounts?.operator ?? 0}{" "}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Recently Managed Users Table */}
            <div className="card mt-4">
              <div className="card-header">
                <h4 className="card-title text-center">
                  Forgot Password requests
                </h4>
              </div>
              <div className="card-body">
                {requestsLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : requests?.length > 0 ? (
                  <Table columns={columns} dataSource={requests} rowKey="Id" />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        )}
        <CommonFooter />
        <Modal
          title="Confirm Password"
          open={isReauthModalVisible}
          onCancel={() => {
            setIsReauthModalVisible(false);
            reauthForm.resetFields();
          }}
          footer={null}
          width={350}
        >
          <Form
            form={reauthForm}
            onFinish={handleReauthentication}
            layout="vertical"
          >
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
            >
              <Input.Password
                placeholder="Enter password"
                onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Authenticate
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                onClick={() => {
                  setIsReauthModalVisible(false);
                  reauthForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <NewUserRequests />
      </div>
    </>
  );
};

export default AssetManagement;
